import React, { useContext } from 'react'
import moment from 'moment'
import { AuthContext } from '../../Auth/AuthContext'
export const Footer = () => {
  const { user } = useContext(AuthContext)
  const version = process.env.REACT_APP_VERSION

  return (
    <footer
      className={`main-footer d-flex justify-content-between align-items-center ${
        (user.role === 2 || user.role === 3) && 'footer-client'
      }`}
    >
      {/* Izquierda */}
      <div className="d-flex align-items-center mt-2" style={{ gap: '8px' }}>
        <strong>Copyright &copy; {moment().format('YYYY')}</strong>

        <a
          href="https://enigmatech.io/en/home-en/"
          target="_blank"
          rel="noopener noreferrer"
          className="logo-footer-hover-wrapper"
        >
          <img
            src="/enigmatech-icono-01.png"
            alt="Mini Logo Enigmatech"
            className="logo-footer-img logo-footer-mini"
            style={{ height: '24px', objectFit: 'contain' }}
          />
          <img
            src="/enigmatech-logo-01.png"
            alt="Logo Enigmatech"
            className="logo-footer-img logo-footer-completo"
            style={{ height: '24px', objectFit: 'contain' }}
          />
        </a>
      </div>

      {/* Derecha */}
      <div className="mt-2">
        <b>Versión</b> {version}
      </div>
    </footer>
  )
}
export default Footer
